export const basicFormData = () => ({
  inputData: {
    menu_name: "",
    menu_url: "",
    menu_icon: "",
    is_child: false,
    parent_id: null,
    is_visible_on_mobile: true,
    sequence: null,
    created_by: 1,
    updated_by: 1,
    is_active: true,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "menu_masters",
  };

  const navigatePage = { back: "/menu-list" };

  const headerName = "Menu";

  const validationType = "MenuCreate";
  const createEndpoint = "/createMenu";
  const updateEndpoint = "/updateMenu";
  const getEndpoint = "/getMenuById";
  const dependentDropdownData = [
    {
      module_name: "menu_masters",
      initialPayload: {
        modelName: "menu_masters",
        whereCondition: { is_child: false },
      },
      isOtherDependentOnThis: false,
      patchFieldName: "menu_name",
      dropdownDataValue: "parent_id",
      endPoint: "/listMenu",
    },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
  };
};

export const listPageData = () => {
  const payload = {
    modelName: "menu_masters",

    relations: [
      {
        module: "user_masters",
        moduleAs: "createdBy",
      },
      {
        module: "user_masters",
        moduleAs: "updatedBy",
      },
      {
        module: "user_masters",
        moduleAs: "updatedBy",
      },
    ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "Menu Name", value: "menu_name" },
    { label: "Menu URL", value: "menu_url" },
    { label: "Menu Icon", value: "menu_icon" },
    { label: "Created By", value: "createdBy.first_name" },
    { label: "Is Child", value: "is_child" },
    { label: "Is Visible On Mobile", value: "is_visible_on_mobile" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/menu-create",
    edit: "/menu-create",
    view: "/menu-view",
  };

  const searchfields = [
    "menu_name",
    "menu_url",
    "menu_icon",
    "createdBy.first_name",
    "createdBy.last_name",
    "updatedBy.first_name",
    "updatedBy.last_name",
  ];

  const headerName = "Menu";
  const endpoint = "/listMenu";
  const exportFileName = "menuData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "menu_masters",
  relations: [
    { module: "user_masters", moduleAs: "createdBy" },
    { module: "user_masters", moduleAs: "updatedBy" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
